import { render, staticRenderFns } from "./AppConfirmButton.vue?vue&type=template&id=63a16dee&scoped=true&"
import script from "./AppConfirmButton.vue?vue&type=script&lang=js&"
export * from "./AppConfirmButton.vue?vue&type=script&lang=js&"
import style0 from "./AppConfirmButton.vue?vue&type=style&index=0&id=63a16dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a16dee",
  null
  
)

export default component.exports